import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GraphQLService } from './graph-ql.service';
@Injectable({
  providedIn: 'root',
})
export class PagesService extends GraphQLService {
  constructor() {
    super();
  }

  getPages(language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('shop', (shop: any) => {
        shop.add('name');
      });
      root.addConnection('pages', { args: { first: 250 } }, (pages: any) => {
        pages.add('id');
        pages.add('title');
        pages.add('body');
        pages.add('updatedAt');
        pages.add('createdAt');
        pages.add('handle');
        pages.add('bodySummary');
        pages.add('seo', (seo: any) => {
          seo.add('title');
          seo.add('description');
        });
      });
    });

    return from(this.client.send(query)).pipe(
      map((a: any) => {
        return a['data'].pages.edges.map((e: any) => e.node);
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.pages.edges.map(e => e.node)));
  }

  getPageByHandle(handle: string, language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('shop', (shop: any) => {
        shop.add('name');
      });
      root.add('pageByHandle', { args: { handle } }, (pages: any) => {
        pages.add('id');
        pages.add('title');
        pages.add('body');
        pages.add('updatedAt');
        pages.add('handle');
        pages.add('bodySummary');
        pages.add('seo', (seo: any) => {
          seo.add('title');
          seo.add('description');
        });
      });
    });
    return from(this.client.send(query)).pipe(
      map((a: any) => {
        return a['data'].pageByHandle;
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.pageByHandle));
  }
}
